import React, { type ReactNode } from 'react';
import Box from '../../atoms/Box';
import SearchField from '../SearchField';

type SearchToolbarProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
  actions?: ReactNode;
};

export default function SearchToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  actions,
}: SearchToolbarProps) {
  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <SearchField
        value={searchValue}
        setValue={onSearchChange}
        placeholder={searchPlaceholder}
        sx={{ flexGrow: 1, maxWidth: 400 }}
      />
      {actions}
    </Box>
  );
}
